import { CourseInstructor, instructorsDegreeTitlePrefix } from "@types";
import { FC } from "react";
import InstructorAvatar from "./InstructorAvatar";
import Link from "next/link";
import classNames from "classnames";
import { toFarsiNumber } from "@utils/digits";
import Graduated from "@svg/new-design/graduated";
import BookIcon from "@svg/new-design/book";
import ClockIcon from "@svg/new-design/clock";
import InstructureStatisticItem from "./InstructureStatisticItem";
import parse from "html-react-parser";
import { commonHtmlParserOptions } from "@utils/html-parser";

interface Props {
  instructorItem: CourseInstructor;
  dense?: boolean;
  hideTopBorder?: boolean;
  isLast: boolean;
}

const CourseInstructorCard: FC<Props> = ({
  instructorItem,
  dense,
  hideTopBorder,
  isLast,
}) => {
  const instructorName = `${
    instructorsDegreeTitlePrefix[instructorItem.instructor_caption] || ""
  } ${instructorItem.first_name} ${instructorItem.last_name}`;

  const statisticItem = [
    {
      icon: Graduated,
      title: "دانشجو",
      value: instructorItem.total_students,
    },
    {
      icon: BookIcon,
      title: "عنوان آموزش",
      value: instructorItem.total_count,
    },
    {
      icon: ClockIcon,
      title: "ساعت آموزش",
      value: Math.floor(instructorItem.total_duration / 60),
    },
  ].filter((item) => item.value);
  const instructureText =
    typeof instructorItem.biography_excerpt === "string"
      ? toFarsiNumber(
          instructorItem.biography_excerpt.replaceAll("<p>&nbsp;</p>", "")
        )
      : "";
  return (
    <div
      className={classNames(
        "  relative ",
        dense
          ? hideTopBorder
            ? "pb-5"
            : isLast
              ? "pt-5 border-t border-dashed border-fds-divider"
              : "border-t py-5 border-dashed border-fds-divider "
          : "rounded-12"
      )}
    >
      <div className="flex w-full items-center gap-2.5   lg:gap-fds-18    mb-5">
        <InstructorAvatar instructorItem={instructorItem} />
        <div>
          <Link href={`/instructors/${instructorItem.slug}`} target="_blank">
            <p className="title-md-demibold md:headline-md truncate w-full mb-3  hover:text-fds-brand">
              {instructorName}
            </p>
          </Link>
          <div className="md:flex w-full hidden items-center">
            {statisticItem.map((statisItm, index) => (
              <>
                <InstructureStatisticItem
                  icon={statisItm.icon}
                  title={statisItm.title}
                  value={statisItm.value}
                />
                {index < statisticItem.length - 1 && (
                  <div className="h-4 border-l border-fds-default mx-3" />
                )}
              </>
            ))}
          </div>
        </div>
      </div>
      <div className="overflow-hidden  body-md text-fds-primary leading-7">
        {parse(instructureText, commonHtmlParserOptions())}
      </div>
    </div>
  );
};

export default CourseInstructorCard;
